import {version} from '../../../../package.json'

export default {
  minivariant: false,
  version: version
};
